"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandColorSize = void 0;
var react_1 = __importDefault(require("react"));
var ColorEditor_1 = __importStar(require("DreamCoat/BrandSetUp/ColorEditor/ColorEditor"));
var mobx_1 = require("mobx");
var classnames_1 = __importDefault(require("classnames"));
var ColorUtils_1 = require("@CommonFrontendBackend/StyleServiceV2/ColorUtils");
var mobx_react_1 = require("mobx-react");
var presetColors_1 = __importDefault(require("./presetColors"));
var react_addons_css_transition_group_1 = __importDefault(require("react-addons-css-transition-group"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var ColorUtils_2 = require("@CommonFrontendBackend/StyleServiceV2/ColorUtils");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var BrandColorSize;
(function (BrandColorSize) {
    BrandColorSize["XSmall"] = "xsmall";
    BrandColorSize["Small"] = "small";
    BrandColorSize["Medium"] = "medium";
})(BrandColorSize || (exports.BrandColorSize = BrandColorSize = {}));
var BrandColors = (function (_super) {
    __extends(BrandColors, _super);
    function BrandColors(props) {
        var _this = _super.call(this, props) || this;
        _this.activeColorIndex = null;
        _this.hoveredColorIndex = null;
        _this.addColorButtonIndex = -1;
        _this.selectionColors = presetColors_1.default.map(function (color, index) { return ({
            value: color,
            themeIndex: index,
        }); });
        _this.maybeAnimateColorDot = function (elem, index) {
            if (_this.props.animateColors) {
                return (react_1.default.createElement(react_addons_css_transition_group_1.default, { transitionName: "brand-colors__color-container--".concat(_this.props.colorSize, "--").concat(index), transitionAppearTimeout: kaleidoscope_1.AnimationDuration.Medium + (index + 1) * 100, transitionEnterTimeout: kaleidoscope_1.AnimationDuration.Medium, transitionLeaveTimeout: kaleidoscope_1.AnimationDuration.Medium, transitionAppear: true, transitionLeave: true, component: react_1.default.Fragment, key: index }, elem));
            }
            else {
                return elem;
            }
        };
        _this.renderColor = function (color, index) {
            return (react_1.default.createElement("div", { className: (0, classnames_1.default)([
                    "brand-colors__color",
                    "brand-colors__color-".concat(index),
                    "brand-colors__color--".concat(_this.props.colorSize),
                ]), onMouseEnter: _this.handleColorOnHover(index), onMouseLeave: _this.handleColorOffHover, style: {
                    backgroundColor: color,
                }, onClick: _this.toggleColorOnClick(index, true) },
                react_1.default.createElement(react_addons_css_transition_group_1.default, { component: react_1.default.Fragment, transitionName: "fade", transitionEnterTimeout: kaleidoscope_1.AnimationDuration.Short, transitionLeaveTimeout: kaleidoscope_1.AnimationDuration.Short }, (_this.hoveredColorIndex === index || _this.activeColorIndex === index) && (react_1.default.createElement("div", { className: (0, classnames_1.default)("brand-colors__edit-icon", {
                        "brand-colors__edit-icon--dark": (0, ColorUtils_2.shouldUseDarkText)(color),
                    }) },
                    react_1.default.createElement(icons_1.Edit, null))))));
        };
        _this.handleEditColor = function (index) {
            return function (updatedColor) {
                (0, mobx_1.runInAction)(function () {
                    if (!(0, ColorUtils_1.isValidColor)(updatedColor)) {
                        return;
                    }
                    _this.props.brandStore.updateColor(updatedColor, index);
                    _this.closeColorEditor();
                });
            };
        };
        _this.handleAddColor = function (newColor) {
            if (!(0, ColorUtils_1.isValidColor)(newColor)) {
                return;
            }
            _this.props.brandStore.addColor(newColor);
            _this.closeColorEditor();
        };
        _this.toggleColorOnClick = function (index, stopPropagation) {
            if (stopPropagation === void 0) { stopPropagation = false; }
            return function (event) {
                (0, mobx_1.runInAction)(function () {
                    if (_this.activeColorIndex === index) {
                        _this.activeColorIndex = null;
                        _this.onClickOutside.stopListening();
                    }
                    else {
                        _this.activeColorIndex = index;
                        _this.onClickOutside.startListening();
                    }
                    if (stopPropagation) {
                        _this.stopClickPropagation(event);
                    }
                });
            };
        };
        _this.handleColorOnHover = function (index) {
            return function () {
                (0, mobx_1.runInAction)(function () {
                    _this.hoveredColorIndex = index;
                });
            };
        };
        _this.handleColorOffHover = function () {
            _this.hoveredColorIndex = null;
        };
        _this.closeColorEditor = function () {
            _this.activeColorIndex = null;
        };
        _this.deleteColor = function (index) {
            return function () {
                (0, mobx_1.runInAction)(function () {
                    _this.props.brandStore.deleteColor(index);
                    _this.activeColorIndex = null;
                });
            };
        };
        _this.stopClickPropagation = function (event) {
            event.stopPropagation();
        };
        _this.onClickOutside = new utils_1.OnClickOutside([".brand-colors__color-editor-".concat(_this.props.colorSize), ".brand-colors__color"], _this.closeColorEditor);
        return _this;
    }
    BrandColors.prototype.componentDidMount = function () {
        this.onClickOutside.startListening();
    };
    BrandColors.prototype.componentWillUnmount = function () {
        this.onClickOutside.stopListening();
    };
    BrandColors.prototype.render = function () {
        var _this = this;
        var _a = this.props, colors = _a.brandStore.colors, hideAddButton = _a.hideAddButton;
        return (react_1.default.createElement("div", { className: "brand-colors", onClick: this.closeColorEditor },
            this.props.children,
            colors.map(function (color, index) {
                return _this.maybeAnimateColorDot(react_1.default.createElement("div", { key: "".concat(index), className: "brand-colors__color-container" },
                    _this.renderColor(color, index),
                    react_1.default.createElement(react_addons_css_transition_group_1.default, { component: react_1.default.Fragment, transitionName: "fade-in-down", transitionEnterTimeout: kaleidoscope_1.AnimationDuration.Medium, transitionLeaveTimeout: kaleidoscope_1.AnimationDuration.Medium }, _this.activeColorIndex === index && (react_1.default.createElement("div", { className: "brand-colors__color-editor-".concat(_this.props.colorSize), onClick: _this.stopClickPropagation },
                        react_1.default.createElement(ColorEditor_1.default, { initialColorValue: color, selectionColors: _this.selectionColors, handleDeleteColor: _this.deleteColor(index), handleActionComplete: _this.handleEditColor(index) }))))), index);
            }),
            !hideAddButton && !this.colorLimitReached && (react_1.default.createElement("div", { className: "brand-colors__color-container", onClick: this.stopClickPropagation },
                react_1.default.createElement("div", { className: (0, classnames_1.default)([
                        "brand-colors__color",
                        "brand-colors__color--add",
                        "brand-colors__color--".concat(this.props.colorSize),
                    ]), onClick: this.toggleColorOnClick(this.addColorButtonIndex) },
                    react_1.default.createElement("div", { className: "brand-colors__add-icon" },
                        react_1.default.createElement(icons_1.Add, null))),
                react_1.default.createElement(react_addons_css_transition_group_1.default, { component: react_1.default.Fragment, transitionName: "fade-in-down", transitionEnterTimeout: kaleidoscope_1.AnimationDuration.Medium, transitionLeaveTimeout: kaleidoscope_1.AnimationDuration.Medium }, this.activeColorIndex === this.addColorButtonIndex && (react_1.default.createElement("div", { className: "brand-colors__color-editor-".concat(this.props.colorSize) },
                    react_1.default.createElement(ColorEditor_1.default, { selectionColors: this.selectionColors, actionType: ColorEditor_1.ActionType.Add, handleActionComplete: this.handleAddColor }))))))));
    };
    Object.defineProperty(BrandColors.prototype, "colorLimitReached", {
        get: function () {
            return this.props.brandStore.colors.length >= this.props.maxColors;
        },
        enumerable: false,
        configurable: true
    });
    BrandColors.defaultProps = {
        maxColors: 7,
        hideAddButton: false,
        animateColors: false,
        colorSize: BrandColorSize.Medium,
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], BrandColors.prototype, "activeColorIndex", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], BrandColors.prototype, "hoveredColorIndex", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BrandColors.prototype, "handleAddColor", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BrandColors.prototype, "handleColorOnHover", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BrandColors.prototype, "handleColorOffHover", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BrandColors.prototype, "closeColorEditor", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], BrandColors.prototype, "colorLimitReached", null);
    BrandColors = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], BrandColors);
    return BrandColors;
}(react_1.default.Component));
exports.default = BrandColors;
